import { render, staticRenderFns } from "./remark_temp_former.vue?vue&type=template&id=22266f5b&"
import script from "./remark_temp_former.vue?vue&type=script&lang=js&"
export * from "./remark_temp_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports